// extracted by mini-css-extract-plugin
module.exports = {"main":"index-module--main--2BKNf","tools":"index-module--tools--1EqIH"};